<script>
import _ from 'lodash'
import moment from 'moment'
export default {
  name: 'AimsPrintList',
  props: {
    data: {
      type: Array,
      default () {
        return []
      }
    },
    hospitalName: {
      type: String,
      default: ''
    },
    date: {
      type: Number,
      default: moment().startOf('day').valueOf()
    }
  },
  data () {
    return {}
  },
  computed: {},
  created: function () {
    this.data = _.sortBy(this.data, ['room', 'arrangedStartTime'])
  },
  mounted: function () {},
  beforeDestroy () {},
  watch: {},
  methods: {},
  filters: {
    arrangeTime (value, item) {
      if (!value) {
        return ''
      }
      return moment(item.arrangedStartTime).format('HH:mm') + '-' + moment(item.arrangedStartTime + item.duration).format('HH:mm')
    }
  }
}
</script>

<template>
  <div class="print-page">
    <div class="text-center" style="padding: 0; margin: 0;">
      <h3><span class="operation-hospital">{{hospitalName}}</span>手术安排一览表(<span class="operation-date">{{date | dateFilter('YYYY年MM月DD日')}})</span></h3>
    </div>
    <table class="print-table border-table" cellspacing="0">
      <thead>
        <tr valign="middle">
          <th width="70" style="text-align: center;">时间</th>
          <th width="70" style="text-align: center;">病历号</th>
          <th width="60" style="text-align: center;">床号</th>
          <th width="40" style="text-align: center;">姓名</th>
          <th width="30" style="text-align: center;">性别</th>
          <th width="40" style="text-align: center;">年龄</th>
          <th style="text-align: center;">诊断+术式</th>
          <th width="8%" style="text-align: center;">设备准备</th>
          <th width="16%" style="text-align: center;">内固定及手术器械准备</th>
          <th width="60" style="text-align: center;">手术室号</th>
          <th width="50" style="text-align: center;">主刀</th>
          <th width="50" style="text-align: center;">一助</th>
          <th width="50" style="text-align: center;">二助</th>
          <th width="50" style="text-align: center;">洗手护士</th>
          <th width="50" style="text-align: center;">巡回护士</th>
          <th width="50" style="text-align: center;">麻醉医生</th>
          <th width="80" style="text-align: center;">麻醉方式</th>
          <th width="8%" style="text-align: center;">备注</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in data" :key="item.id">
          <td style="text-align: center;">{{item.arrangedStartTime | arrangeTime(item)}}</td>
          <td style="text-align: center;">{{item.historySn}}</td>
          <td style="text-align: center;">{{item.bedid}}</td>
          <td style="text-align: center;">{{item.patName}}</td>
          <td style="text-align: center;">{{item.sex % 2 === 0 ? '女' : '男'}}</td>
          <td style="text-align: center;">{{item.age}}</td>
          <td>{{item.diagnoseNames}};{{item.operatingNames}}</td>
          <td>{{item.device}}</td>
          <td>{{item.specialPrepare}}</td>
          <td style="text-align: center;">{{item.roomName}}</td>
          <td>{{item.operatorName}}</td>
          <td>{{item.assistantFirstName}}</td>
          <td>{{item.assistantSecondName}}</td>
          <td>{{item.washNurseName}}</td>
          <td>{{item.tourNurseName}}</td>
          <td>{{item.anesthesiaDocName}}</td>
          <td>{{item.anesthesiaType}}<span v-if="item.anesthesiaAdditional">({{item.anesthesiaAdditional}})</span></td>
          <td>{{item.remark}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.text-center {
  text-align: center;
}
.print-page {
  color: #000;
  background: #fff;
}
.print-table {
  color: #000;
  font-size: 12px;
}
.border-table {
  border-top: 1px solid #000;
  border-left: 1px solid #000;
}
.border-table th,
.border-table td {
  border-right: 1px solid #000;
  border-bottom: 1px solid #000;
}
</style>
